import { CoverImage } from "./components/CoverImage";
import { CoverImageEvent } from "./components/CoverImageEvent";
import type { CoverImageInterface } from "./types";

export const CoverImageRaw = ({
  paywall,
  coverImageClassName,
  eventImageClassName,
}: CoverImageInterface) => {
  if (paywall?.event) {
    return <CoverImageEvent className={eventImageClassName} />;
  }

  if (paywall?.paywall_customization?.cover_image) {
    return (
      <CoverImage
        {...paywall.paywall_customization}
        className={coverImageClassName}
      />
    );
  }

  return null;
};
